import { JetView } from 'webix-jet';
import { devConfig, countries, profile, cashDesks, agentList, walletsList } from 'config/config';

/**
 * Class representing the FilterInformeGerencialView.
 * @extends JetView
 */
export default class FilterInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default value set to current date
                            format: '%M %Y',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for country selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            on: {
                                /**
                                 * Event handler for country selection change.
                                 * Enables or disables the consult button based on selection.
                                 * @param {String} data - The selected value.
                                 * @param {Object} obj - The object containing the event data.
                                 */
                                onChange: function (data, obj) {
                                    var currentValue = this.getValue();
                                    if (screen.width > 600) {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk').enable();
                                        } else {
                                            $$('consultDesk').disable();
                                        }
                                    } else {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk2').enable();
                                        } else {
                                            $$('consultDesk2').disable();
                                        }
                                    }
                                },
                            },
                            options: {
                                body: {
                                    /**
                                     * Template for displaying country options with flags.
                                     * @param {Object} obj - The country object.
                                     * @returns {String} The HTML string for the option.
                                     */
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for country options
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the second country selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Set as read-only
                            options: {
                                body: {
                                    /**
                                     * Template for displaying country options with flags.
                                     * @param {Object} obj - The country object.
                                     * @returns {String} The HTML string for the option.
                                     */
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for country options
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry country-hide',
                        },
                        {
                            view: 'richselect',
                            name: 'TypeBet',
                            label: _('Tipo de Apuesta'), // Label for bet type selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: 2, // Default value set to 'Apuestas Cerradas'
                            options: [
                                { id: '1', value: _('Apuestas Creadas') }, // Option for created bets
                                { id: '2', value: _('Apuestas Cerradas') }, // Option for closed bets
                            ],
                        },
                        {
                            view: 'combo',
                            name: 'WalletId',
                            minWidth: 200,
                            localId: 'wallet:combo',
                            hidden: devConfig.getPartnerSelected() !== '2' ? true : false, // Conditional visibility based on partner selection
                            label: _('Tipo de Billetera'), // Label for wallet type selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            suggest: walletsList, // Data source for wallet options
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    height: screen.width > 500 && screen.height > 500 ? 0 : 120,
                    cols: [
                        {
                            view: 'radio',
                            name: 'TypeUser',
                            label: _('Tipo de usuario'), // Label for user type selection
                            labelPosition: 'top',
                            value: 0, // Default value set to 'Todos'
                            options: [
                                { id: 0, value: _('Todos') }, // Option for all users
                                {
                                    id: 1,
                                    value: "<span class='icon-players'></span> ", // Option for player type
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-shop'></span>", // Option for shop type
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Contains the left section with filters
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear the form
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Clear datepicker value
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter data
                    hotkey: 'enter', // Shortcut key for the button
                    id: 'consultDesk',
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear the second form
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('Datepicker').setValue(''); // Clear datepicker value
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter data
                    hotkey: 'enter', // Shortcut key for the button
                    type: 'form',
                    id: 'consultDesk2',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Contains upper section
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Contains accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the view.
     */
    init(grid) {
        webix.ready(function () {
            if (devConfig.getCountryReport()) {
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable consult button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable consult button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
